module.exports = __webpack_public_path__ + "img/commodity-002.7dee1fd9.png";